/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：624
 */

module.exports = {
  groupPopover: "style_groupPopover__-rV_a",
  groupPopoverContent: "style_groupPopoverContent__3FHFA",
  selected: "style_selected__19k-5",
  playArea: "style_playArea__Bef48",
  infoArea: "style_infoArea__q5FsJ",
  selectedIconWrap: "style_selectedIconWrap__udtBb"
}
